import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";

import { ReturnLargeItem } from "../../models/returns/IReturnsApi";
import classNames from "../../utils/classNames";

/** Red: too big for a normal courier, collection has to be arranged. Amber: the size needs checking. */
export function LargeItemBanner({ item }: { item: ReturnLargeItem }) {
  const red = item.level === "red";
  return (
    <div role="status" className={classNames("flex items-start gap-2.5 rounded-xl border px-3.5 py-2.5 text-[13px]", red ? "border-red-200 bg-red-50 text-red-900" : "border-amber-200 bg-amber-50 text-amber-900")}>
      <ExclamationTriangleIcon className={classNames("mt-0.5 h-4 w-4 shrink-0", red ? "text-red-700" : "text-amber-600")} />
      <span className="flex min-w-0 flex-col gap-0.5">
        <strong className="font-semibold">{item.title}</strong>
        <span>{item.reason}</span>
      </span>
    </div>
  );
}

/** The list row's pill; the reason is in the tooltip. */
export function LargeItemPill({ item }: { item: ReturnLargeItem }) {
  const { t } = useTranslation("returns");
  const red = item.level === "red";
  return (
    <span title={item.reason} className={classNames("whitespace-nowrap rounded px-1.5 py-px text-[10px] font-semibold", red ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700")}>
      {red ? t("Large item") : t("Check size")}
    </span>
  );
}
